module.exports = __webpack_public_path__ + "static/media/lexservices4-292x300.f033b031.png";